import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";

import getDatos from "../../../services/getDatos";

export const TipoFuente = ({ tipoFuente: idTipoFuente, handleChange }) => {
  const [tipoFuente, setTipoFuente] = useState([]);

  useEffect(() => {
    async function aux() {
      const data = await getDatos("atributos/datoabiertocombos");
      setTipoFuente(data.resultFuente);
    }
    aux();
  }, []);

  return (
    <>
      <Form.Select
        className="inputs-forms-admin focus-admin-register"
        name="tipoFuente"
        value={idTipoFuente}
        onChange={handleChange}
      >
        <option selected>Seleccione...</option>
        {tipoFuente.map((e, i) => {
          <option selected>Seleccione...</option>;
          return (
            <option key={e.id_tipo_fuente} value={e.id_tipo_fuente}>
              {e.descripcion}
            </option>
          );
        })}
      </Form.Select>
    </>
  );
};
